/**
 * jQuery plugin that converts elements to autosuggests or selectboxes.
 * DEPENDENCIES:
 * - jQuery
 *
 * @package 	simPRO
 * @subpackage  jQuery
 * @category    jQuery Plugin
 * @version 	2012-05-03 1.0
 * @author  	Michael West
 **/
var resultsPanelOpen = null;
(function($){
    var methods = {
        /* PUBLIC METHODS */
        create: function (options) {
            var options = $.extend({
                "optionsList": [],
                "buttonClasses": "",
                "caseSensitive": false,
                "delay": 300,
                "filter": true,
                "filterPlaceholder": "Search...",
                "minLength": 1,
                "nothingSelectedLabel": "0 selected",
                "position": {
                    "my": "left top",
                    "at": "left bottom",
                    "collision": "flip flip"
                },
                "results": [],
                "resultsClasses": "",
                "selectAllOption": true,
                "selectAllLabel": "Select All",
                "selectedLabel": "[x] selected",
                "unselectAllLabel": "Unselect All",
                "mode": 'contains',
                "close": function(){},
                "create": function(){},
                "open": function(){},
                "search": function(){},
                "select": function(){}
            }, options);
            return this.each(function(){
                var $this = $(this);
                var data = $this.data("suggestselect");
                if (!data) {
                    $this.data("suggestselect", {
                        "optionsList": [],
                        "category": null,
                        "disabled": false,
                        "hidden": false,
                        "hoverIndex": null,
                        "hoverText": null,
                        "multiple": false,
                        "multiplewithnone": false,
                        "multiplewithnonefirstvalue": null,
                        "namespace": ".suggestselect-" + Math.floor(Math.random() * 1000000),
                        "numResults": null,
                        "options": $.extend({}, options),
                        "resultsPanel": null,
                        "searchText": null,
                        "initialValue": null,
                        "type": "suggest",
                        "closed": true
                    });
                    var data = $this.data("suggestselect");
                    data.disabled = $this.is(":disabled");
                    data.hidden = $this.css("display") == "none" || $this.css("visibility") == "hidden";
                    if ($this.is("select")) {
                        $this.hide();
                        data.type = "select";
                        var subLabel = '';
                        if ($this.attr("multiple")) {
                            data.multiple = true;
                            var label = data.options.nothingSelectedLabel;
                            if ($this.attr("data-none-option")) {
                                data.multiplewithnone = true;
                                data.multiplewithnonefirstvalue = $this.find("option:eq(0)").val();
                            }
                        } else {
                            var select = $this.get(0);
                            var selectOption = $(select.options[select.selectedIndex]);
                            var label = encodeURIComponent(selectOption.text()); // encode to prevent recoding html encoded label
                            if (selectOption.data("sublabel") && selectOption.data("subshowlabel"))
                            {
                                subLabel = encodeURIComponent(selectOption.data("sublabel"));
                            }
                        }
                        let thisClass = '';
                        if (typeof $this.data('suggestselect-class') !== 'undefined') {
                            thisClass = ' ' + $this.data('suggestselect-class');
                        }
                        var suggestselect = $("<button data-cy='suggestSelectButton' class='suggestselectButton ui-widget ui-widget-content" + thisClass + "'" + ($this.attr("tabindex") ? " tabindex='" + $this.attr("tabindex") + "'" : "") + " type='button'><span class='label'>" + label + "</span><span class='subLabel'>" + subLabel + "</span><span class='ui-icon ui-icon-triangle-2-n-s'></span></button>").addClass(options.buttonClasses).insertAfter($this);
                        $(suggestselect).children().click(function(event){
                            event.stopPropagation();
                            // Checks for "disabled" attribute on the button before proceeding
                            if (!$(this).parent().is(':disabled')) {
                                $(this).parent().click();
                            }
                        });
                    } else {
                        var suggestselect = $this;
                    }
                    $this.addClass("suggestSelect");
                    data.suggestselect = suggestselect;
                    $this.suggestselect("refresh");

                    var delayIntval, hoverTextIntval;
                    suggestselect.bind("click" + data.namespace, function(){
                        if (data.initialValue == null && data.type == "select") {
                            data.initialValue = $this.val();
                        }
                        // Trigger a search on focus
                        if (data.type == "select" && data.resultsPanel) {
                            $this.suggestselect("close");
                        } else {
                            if (data.type == "select") {
                                var value = "";
                            } else {
                                var value = $this.val();
                            }
                            $this.suggestselect("search", value);
                        }
                        $(this).focus().select();
                    }).bind("keyup" + data.namespace, function(event){
                        data = $this.data("suggestselect");
                        if ((event.keyCode != 9 && event.keyCode != 13 && event.keyCode != 27 && event.keyCode != 38 && event.keyCode != 40) || ((event.keyCode == 38 || event.keyCode == 40) && !data.resultsPanel)) {
                            // Trigger a search on keyup
                            if (data.type == "select" || event.keyCode == 38 || event.keyCode == 40) {
                                var delay = 0;
                            } else {
                                var delay = options.delay;
                            }
                            var isFilter = false;
                            if (data.type == "select") {
                                var filterInput = $(data.resultsPanel).find("input");
                                isFilter = options.filter && filterInput.length > 0;

                                if (isFilter) {
                                    var value = filterInput.val();
                                } else {
                                    var value = "";
                                }
                            } else {
                                var value = $this.val();
                            }
                            if (delay > 0) {
                                data.closed=false;
                                window.clearTimeout(delayIntval);
                                delayIntval = window.setTimeout(function(){
                                    if (!$this.data("suggestselect").closed) {
                                        $this.suggestselect("search", value);
                                    }
                                }, delay);
                            } else {
                                $this.suggestselect("search", value);
                            }
                        }
                    }).bind("keydown" + data.namespace, function(event) {
                        data = $this.data("suggestselect");
                        if (data.initialValue == null) {
                            data.initialValue = $this.val();
                        }
                        if (data.resultsPanel && (event.keyCode == 9 || event.keyCode == 13 || event.keyCode == 38 || event.keyCode == 40)) {
                            // Allow options to be selected via keyboard
                            if (event.keyCode == 38 || event.keyCode == 40) {
                                event.preventDefault();
                                // Scroll through options
                                var hoverIndex = data.hoverIndex;
                                if (event.keyCode == 38) {
                                    // Up
                                    if (hoverIndex == null || hoverIndex <= 0 || hoverIndex >= data.numResults) {
                                        hoverIndex = data.numResults - 1;
                                    } else {
                                        hoverIndex--;
                                    }
                                } else {
                                    // Down
                                    if (hoverIndex == null || hoverIndex >= data.numResults - 1 || hoverIndex < 0) {
                                        hoverIndex = 0;
                                    } else {
                                        hoverIndex++;
                                    }
                                }
                                data.hoverIndex = hoverIndex;

                                var hoverSelected = data.resultsPanel.find("li.option:eq(" + data.hoverIndex + ")");
                                var hoverSelectedHeight = $(hoverSelected).height();
                                $(hoverSelected).trigger("blur").trigger("customfocus");
                                var height = data.resultsPanel.height();
                                var scrollTop = data.resultsPanel.scrollTop() + $(hoverSelected).position().top;
                                if (scrollTop > height - hoverSelectedHeight) {
                                    data.resultsPanel.scrollTop(scrollTop - height + hoverSelectedHeight);
                                } else {
                                    data.resultsPanel.scrollTop(0);
                                }
                            } else {
                                // Select option when enter or tab is pressed
                                if (data.hoverIndex === null || (data.multiple && event.keyCode == 9)) {
                                    $this.suggestselect("close");
                                } else {
                                    data.resultsPanel.find("li.option:eq(" + data.hoverIndex + ")").click();
                                }
                                if (data.type == "select" && event.keyCode == 13) {
                                    return false;
                                }
                            }
                        } else if (event.keyCode != 27 && data.resultsPanel && data.type == "select") {
                            if (event.keyCode >= 48 && event.keyCode <= 90) {
                                // Scroll through options on keydown
                                if (!data.hoverText) {
                                    data.hoverText = "";
                                    data.hoverIndex = 0;
                                }
                                data.hoverText += String.fromCharCode(event.keyCode).toLowerCase();
                                $this.find("option").each(function(index){
                                    if (index >= data.hoverIndex) {
                                        // select item if it has a valid value and matches hovertext
                                        if ($(this).text().toLowerCase().substring(0, data.hoverText.length) == data.hoverText.toLowerCase()) {
                                            data.hoverIndex = index;
                                            if (index > 0 || ($(this).val() !== '' && parseInt($(this).val()) > 0)) {
                                                return false;
                                            }
                                        }
                                    }
                                });

                                var hoverSelected = data.resultsPanel.find("li.option:eq(" + data.hoverIndex + ")");
                                var hoverSelectedHeight = $(hoverSelected).height();
                                $(hoverSelected).blur().trigger("customfocus");
                                var height = data.resultsPanel.height();
                                var scrollTop = data.resultsPanel.scrollTop() + $(hoverSelected).position().top;
                                if (scrollTop > height - hoverSelectedHeight) {
                                    data.resultsPanel.scrollTop(scrollTop - height + hoverSelectedHeight);
                                } else {
                                    data.resultsPanel.scrollTop(0);
                                }

                                window.clearTimeout(hoverTextIntval);
                                hoverTextIntval = window.setTimeout(function(){
                                    data.hoverText = null;
                                }, 750);
                            }
                        } else if (event.keyCode == 9 || event.keyCode == 27) {
                            // Close results panel when tab or esc key is pressed
                            $this.suggestselect("close");
                        }
                    });

                    $this.suggestselect("createEvent");
                } else {
                    var data = $this.data("suggestselect");
                    data.options = $.extend(data.options, options);
                    $this.data("suggestselect", data);
                    $this.suggestselect("refresh");
                }
            });
        },
        destroy: function(){
            return this.each(function(){
                var $this = $(this);
                var data = $this.data("suggestselect");
                var suggestselect = data.suggestselect;

                suggestselect.unbind(data.namespace);
                $(window).unbind(data.namespace);
                if (data.type == "select") {
                    suggestselect.remove();
                    $this.show();
                }
                $this.removeClass("suggestSelect");
                $this.removeData("suggestselect");
            });
        },
        refresh: function(event){
            return this.each(function(){
                var $this = $(this);
                var data = $this.data("suggestselect");
                var options = data.options;
                var suggestselect = data.suggestselect;
                if (!event) {
                    event = {
                        "type": null
                    };
                }
                if (data.type == "select") {
                    if (event.type != "resize") {
                        var oneSelected = false;
                        if (data.multiple) {
                            var selectedOption = $this.find("option:selected");
                            var numSelected = selectedOption.length;
                            if (numSelected > 1) {
                                var text = options.selectedLabel.replace("[x]", numSelected);
                            } else if (numSelected == 1) {
                                oneSelected = true;
                            } else {
                                var text = data.options.nothingSelectedLabel;
                            }
                        } else {
                            var select = $this.get(0);
                            var selectedOption = select.options[select.selectedIndex];
                            oneSelected = true;
                        }
                        var subLabel = $(selectedOption).data('sublabel');
                        var showSubLabel = $(selectedOption).data('showsublabel'); // display sublabel on selected field
                        if (oneSelected) {
                            var text = $(selectedOption).text();
                            // Set background
                            var option = $(selectedOption).get(0);
                            if (option) {
                                var background = option.style.backgroundColor;
                                let color = option.style.color;
                                if (background) {
                                    data.suggestselect.get(0).style.setProperty("background", background, "important");
                                } else {
                                    data.suggestselect.get(0).style.removeProperty("background-color");
                                }

                                if (color) {
                                    data.suggestselect.get(0).style.setProperty("color", color, "important");
                                } else {
                                    data.suggestselect.get(0).style.removeProperty("color");
                                }

                            }
                        } else {
                            // Clear background
                            data.suggestselect.get(0).style.removeProperty("background-color");
                            data.suggestselect.get(0).style.removeProperty("color");
                        }
                        // Set label
                        // if text is empty, we need to set it up to &nbsp; otherwise it change the default height of the element
                        if (text === '') {
                            data.suggestselect.find("span.label").html('&nbsp;');
                        } else {
                            data.suggestselect.find("span.label").text(text);
                            if (subLabel && showSubLabel == 1) {
                                data.suggestselect.find("span.subLabel").text(subLabel);
                            } else {
                                data.suggestselect.find("span.subLabel").html('&nbsp;');
                            }
                        }
                    }
                }
                // Resize and position results panel
                if (data.resultsPanel) {
                    //data-match should be used when a suggestselect element isn't the size of the results panel we want to drop down (we want to match it to a search bar width etc)
                    var $Element = (suggestselect.data('match')) ? suggestselect.closest(suggestselect.data('match')) : suggestselect;
                    var suggestselectWidth = suggestselect.data("results-panel-width") ? suggestselect.data("results-panel-width") : $Element.outerWidth();
                    var offset = $Element.offset();
                    var offsetTop = offset.top + $Element.outerHeight();
                    if (!$Element.is("#searchProject")) {
                        offsetTop -= parseInt($Element.css("border-bottom-width").replace('px', ''));
                    }

                    data.resultsPanel.css({
                        "position": "absolute",
                        "top": offsetTop,
                        "left": offset.left
                    });
                    if (suggestselectWidth > parseInt(data.resultsPanel.css("width"))) {
                        // make sure the outer width is the same width as the suggest select box itself
                        data.resultsPanel.outerWidth(suggestselectWidth);
                    } else {
                        data.resultsPanel.css("minWidth", suggestselectWidth);
                    }

                    data.resultsPanel.show();
                    if ($.ui && $.ui.position) {
                        var position = options.position;
                        position.of = data.suggestselect;
                        data.resultsPanel.position(position);
                    }
                    if (data.type == "select") {
                        let optionObject = $(".ui-state-active", data.resultsPanel);
                        if (optionObject.length) {
                            // scrollTop have issues with IE/edge browser
                            let isIE = /edge|msie\s|trident\//i.test(window.navigator.userAgent);
                            if (!isIE) {
                                let scrollPosition = 0;
                                scrollPosition = optionObject.offset().top - data.resultsPanel.offset().top + data.resultsPanel.scrollTop();
                                if (options.filter) {
                                    let filter = $(".filterPanel", data.resultsPanel);
                                    if (filter.length) {
                                        scrollPosition -= filter.innerHeight();
                                    }
                                }
                                // to fix issue where the selected option is not visible in the dropdown box when there are many items selected
                                data.resultsPanel.scrollTop(scrollPosition);
                            }
                        }
                    }
                }

                if (event.type != "resize") {
                    // Disable / enable
                    suggestselect.prop("disabled", data.disabled);
                    $this.prop("disabled", data.disabled);

                    // Show / hide
                    if (data.hidden) {
                        suggestselect.hide();
                    } else {
                        suggestselect.show();
                    }
                }
            });
        },
        setValue: function(value){
            return this.each(function(){
                var $this = $(this);
                $this.val(value).suggestselect("refresh");
            });
        },
        setIndex: function(value){
            return this.each(function(){
                var $this = $(this);
                $this.prop("selectedIndex", value).suggestselect("refresh");
            });
        },
        disable: function(){
            return this.each(function(){
                var $this = $(this);
                var data = $this.data("suggestselect");
                data.disabled = true;
                $this.suggestselect("refresh");
            });
        },
        enable: function(){
            return this.each(function(){
                var $this = $(this);
                var data = $this.data("suggestselect");
                data.disabled = false;
                $this.suggestselect("refresh");
            });
        },
        hide: function(){
            return this.each(function(){
                var $this = $(this);
                var data = $this.data("suggestselect");
                data.hidden = true;
                $this.suggestselect("refresh");
            });
        },
        show: function(){
            return this.each(function(){
                var $this = $(this);
                var data = $this.data("suggestselect");
                data.hidden = false;
                $this.suggestselect("refresh");
            });
        },
        search: function(searchText, forceSearch){
            return this.each(function(){
                var $this = $(this);
                var data = $this.data("suggestselect");
                var options = data.options;
                if (!data.disabled) {
                    if (forceSearch || ((data.type == "select" || searchText.length >= options.minLength) && searchText != data.searchText)) {
                        data.closed = false;
                        data.numResults = 0;
                        data.searchText = searchText;
                        data.category = null;
                        $this.suggestselect("_getResults");
                    } else if (data.type != "select" && searchText.length < options.minLength) {
                        // Close if search text doesn't meet minimum length
                        if (data.resultsPanel) {
                            data.resultsPanel.remove();
                            data.resultsPanel = false;
                        }
                    }
                }
            });
        },
        close: function(){
            return this.each(function(){
                var $this = $(this);
                var data = $this.data("suggestselect");
                if (!data.closed) {
                    var suggestselect = data.suggestselect;
                    if (data.resultsPanel) {
                        data.resultsPanel.remove();
                    }
                    data.closed=true;
                    data.hoverIndex = null;
                    data.numResults = null;
                    data.resultsPanel = null;
                    data.searchText = null;
                    $(document).unbind("click" + data.namespace);
                    $this.suggestselect("closeEvent");
                }
            });
        },
        option: function(option, value){
            return this.each(function(){
                var $this = $(this);
                var data = $this.data("suggestselect");
                var options = data.options;
                var suggestselect = data.suggestselect;
                options[option] = value;
                $this.suggestselect("refresh");
            });
        },

        /* PRIVATE METHODS */
        _getResults: function(){
            var $this = $(this);
            var data = $this.data("suggestselect");
            var options = data.options;
            if (data.type != "select" && typeof data.options.results === "function") {
                options.results(data.searchText, $this);
            } else {
                if (data.type == "select") {
                    data.options.results = $this.find("option:not(.hide)");
                }
                var results = [];
                $.each(options.results, function(index, item){
                    if (typeof item === "string") {
                        var result = {};
                        result.label = item;
                    } else if (data.type != "select" && typeof item === "object") {
                        var result = item;
                    } else {
                        var result = {};
                        result.category = $(item).parents("optgroup:first").attr("label");
                        result.label = $(item).html();
                        result.subLabel = $(item).data('sublabel');
                        result.attributes = $(item).getAttributes();
                    }
                    result.item = item;
                    if (data.searchText === '') {
                        results.push(result);
                    } else if (data.type === "select" && index === 0 && ($(this).val() === "" || parseInt($(this).val()) <= 0)) {
                        // skip not selected when filtering select
                    } else if (
                        (options.mode === 'contains' && ((options.caseSensitive && result.label.indexOf(data.searchText) != -1) || (!options.caseSensitive && result.label.toLowerCase().indexOf(data.searchText.toLowerCase()) != -1)))
                        ||
                        (options.mode === 'begins' && ((options.caseSensitive && result.label.indexOf(data.searchText) == 0) || (!options.caseSensitive && result.label.toLowerCase().indexOf(data.searchText.toLowerCase()) == 0)))
                    ) {
                        results.push(result);
                    }
                });
                $this.suggestselect("_showResults", results);
            }
        },
        _showResults: function(results){
            var $this = $(this);
            var data = $this.data("suggestselect");
            data.optionsList = [];
            if (!data.closed) {
                if (results.length == 0 && data.type != "select") {
                    if (data.resultsPanel) {
                        data.resultsPanel.remove();
                        data.resultsPanel = false;
                    }
                } else {
                    var openEvent = false;
                    if (data.resultsPanel) {
                        data.resultsPanel.find("li.category, li.option").remove();
                    } else if (results.length > 0) {
                        $this.suggestselect("_addResultsPanel");
                        openEvent = true;
                    }

                    const currOpts = $this.find("option");
                    $.each(results, function (index, result) {
                        if (data.type == "select") {
                            index = currOpts.index(result.item);
                        }
                        $this.suggestselect("_addOption", index, result);
                    });

                    data.resultsPanel.append(data.optionsList);

                    if (data.resultsPanel) {
                        data.resultsPanel.css({
                            "minWidth": data.resultsPanel.width()
                        }).hide();
                    }
                    if (openEvent) {
                        $this.suggestselect("openEvent");
                    }
                    $this.suggestselect("searchEvent").suggestselect("refresh");

                }
            }
        },
        _addResultsPanel: function(){
            var $this = $(this);
            var data = $this.data("suggestselect");
            var options = data.options;

            // Add results panel
            if (data.type == "select") {
                data.resultsPanel = $("<ul data-cy='selectSuggestion' class='suggestselectResults ui-menu ui-widget ui-widget-content'></ul>").addClass(options.resultsClasses).appendTo("body");
            } else {
                data.resultsPanel = $("<ul data-cy='selectSuggestion' class='suggestselectResults ui-menu ui-widget ui-widget-content'></ul>").addClass(options.resultsClasses).appendTo("body");
            }

            // Set z-index to display over dialogBox
            if ($this.closest('.dialogBox').length) {
                data.resultsPanel.addClass('overDialogBox');
            }

            if (typeof($this.attr("id")) != 'undefined') {
                data.resultsPanel.attr("id", $this.attr("id") + "Results");
            }
            if (data.type == "select") {
                if (options.filter || data.multiple) {
                    // Add filter
                    var filterPanel = $("<li class='filterPanel ui-widget-header'></li>").appendTo(data.resultsPanel);
                    $("<input type='text' class='filter' placeholder='" + options.filterPlaceholder + "' />").appendTo(filterPanel).keyup(function(event){
                        data.suggestselect.trigger(event);
                        $(data.resultsPanel).scrollTop(0);
                    }).keydown(function(event){
                        // allow arrow keys to be used to choose filtered results
                        if (event.keyCode == 9 || event.keyCode == 13 || event.keyCode == 38 || event.keyCode == 40) {
                            if (event.keyCode == 9 && data.hoverIndex == null) {
                                data.hoverIndex = 0;
                            }
                            data.suggestselect.trigger(event);
                        }
                    });
                }
                if (data.multiple && options.selectAllOption) {
                    $(data.resultsPanel).addClass("multiple");
                    // Add select all / unselect all options
                    var selectAllPanel = $("<li class='selectAllPanel ui-widget-header'></li>").appendTo(data.resultsPanel);
                    // Select all
                    $("<a href='javascript: void(0);'><span class='ui-icon ui-icon-check'></span><span class='label'>" + options.selectAllLabel + "</span></a>").appendTo(selectAllPanel).click(function(){
                        let change = ($this.find("option").length != $this.find("option:selected").length);
                        $this.find("option").prop("selected", true);
                        $(data.resultsPanel).find(":checkbox").prop("checked", true);
                        data.suggestselect.focus();
                        $this.suggestselect("refresh");
                        if (change) {
                            $this.trigger('change');
                        }
                    });
                    // Unselect all
                    $("<a href='javascript: void(0);'><span class='ui-icon ui-icon-closethick'></span><span class='label'>" + options.unselectAllLabel + "</span></a>").appendTo(selectAllPanel).click(function(){
                        let change = $this.find("option:selected").length > 0;
                        $this.find("option").prop("selected", false);
                        $(data.resultsPanel).find(":checkbox").prop("checked", false);
                        data.suggestselect.focus();
                        $this.suggestselect("refresh");
                        if (change) {
                            $this.trigger('change');
                        }
                    });
                }

            }
            $(document).bind("click" + data.namespace, function(event){
                // Close when suggestselect loses focus
                var triggerClose = true;
                if ($(event.target).is($(data.suggestselect))) {
                    triggerClose = false;
                } else {
                    $(event.target).parents().each(function(){
                        if ($(this).is(data.resultsPanel)) {
                            triggerClose = false;
                            return false;
                        }
                    });
                    if (triggerClose) {
                        $this.suggestselect("close");
                    }
                }
                if (data.multiple && data.multiplewithnone) {
                    let $firstOption = $(data.resultsPanel).find("li.option:eq(0)");
                    let $notFirstOption = $(data.resultsPanel).find("li.option:gt(0)");
                    let $dataResultPanelNoneCheckbox = $firstOption.find(":checkbox");
                    let $dataResultPanelValueCheckbox = $notFirstOption.find(":checkbox");
                    let $selectNoneCheckbox = $this.find("option:eq(0)");
                    let $selectValueCheckbox = $this.find("option:gt(0)");
                    $dataResultPanelNoneCheckbox.removeClass('disabled');
                    $dataResultPanelValueCheckbox.removeClass('disabled');
                    $selectNoneCheckbox.removeClass('disabled');
                    $selectValueCheckbox.removeClass('disabled');
                    if ($this.val() != null) {
                        if ($this.find("option:eq(0):selected").val() == data.multiplewithnonefirstvalue && ($this.find("option").length > $this.val().length)) {
                            $selectValueCheckbox.prop("selected", false).addClass('disabled').removeAttr('selected');
                            $dataResultPanelValueCheckbox.prop("checked", false).addClass('disabled');
                        } else if ($this.find("option:gt(0):selected").length > 0) {
                            $selectNoneCheckbox.prop("selected", false).addClass('disabled');
                            $dataResultPanelNoneCheckbox.prop("checked", false).addClass('disabled');
                        }
                    }
                    $this.suggestselect("refresh");
                }
            });
        },
        _addOption: function(index, result){
            var $this = $(this);
            var data = $this.data("suggestselect");

            //add only if it is not hidden in the parent list
            if (typeof result.item === "undefined"
                || typeof result.item.style === "undefined"
                || result.item.style.display !== "none"
            ) {
                if (result.category && data.category != result.category) {
                    // Add category
                    data.optionsList.push($("<li class='category ui-menu-item'>" + result.category + "</li>"));
                    data.category = result.category;
                }
                if (result.label != "") {
                    // Add option
                    var option = $("<li class='option ui-menu-item' value='" + (typeof(result.attributes) !== "undefined" ? result.attributes.value : '') + "'><a href='javascript: void(0);'><span class='label'>" + result.label + "</span></a></li>")
                    data.optionsList.push(option);
                    if (result.subLabel && result.subLabel != "") {
                        $("<span class='subLabel'>" + result.subLabel + "</span>").appendTo(option.find(".label"));
                    }
                    $(option).on("mousemove mouseleave customfocus blur", function(event){
                        if (event.type == "mouseleave" || event.type == "blur"){
                            $(this).find("a:first").removeClass("ui-state-hover");
                        } else {
                            $(this).parent().find("a").removeClass("ui-state-hover");
                            $(this).find("a:first").addClass("ui-state-hover");
                        }
                    }).click(function (event) {
                        var change = false;
                        if (data.type == "select"){
                            var selectedOption = $this.find("option:eq(" + index + ")");
                            if (data.multiple){
                                if ($(selectedOption).prop("selected")){
                                    $(selectedOption).prop("selected", false).attr("selected", false);
                                    $(this).find(":checkbox").prop("checked", false).attr("checked", false);
                                } else {
                                    $(selectedOption).prop("selected", true).attr("selected", true);
                                    $(this).find(":checkbox").prop("checked", true).attr("checked", true);
                                }
                                change = true;
                            } else {
                                var oldIndex = $this.prop("selectedIndex");
                                $this.find("option").prop("selected", false).attr("selected", false);
                                $(selectedOption).prop("selected", true).attr("selected", true);
                                if (oldIndex != $this.prop("selectedIndex")){
                                    change = true;
                                }
                            }
                        } else {
                            // Change value of suggestselect to selected item's label
                            data.suggestselect.val($(this).find("a span.label").clone().children().remove().end().text());
                        }
                        data.suggestselect.focus();
                        if (result.item){
                            var element = result.item;
                        } else {
                            var element = result;
                        }
                        $this.suggestselect("refresh").suggestselect("selectEvent", element, event);
                        if (!data.multiple){
                            $this.suggestselect("close");
                        }
                        if (change){
                            $this.change();
                        }
                    });
                    if (data.type == "select") {
                        var selectOption0 = $this[0].options[index];
                        var selectOption = $(selectOption0);
                        if (selectOption0){
                            // Set background
                            let option0 = $(option).get(0);
                            option0.style.setProperty("background", selectOption0.style.backgroundColor, "important");
                            $(option).find("a span").css('color', selectOption0.style.color);
                            option0.style.setProperty("border-top", selectOption0.style.borderTop, "important");
                            option0.style.setProperty("padding", selectOption0.style.padding, "important");
                            $(option).find("a span.subLabel").css('display', selectOption0.style.display, "important");
                        }
                        if (data.multiple){
                            // Add checkbox
                            if (selectOption.prop("selected")){
                                var checked = " checked='checked'";
                            } else {
                                var checked = "";
                            }
                            $("<input type='checkbox' class='checkbox'" + checked + " />").prependTo($(option).find("a"));
                        } else if (index == $this.prop("selectedIndex")){
                            // Highlight selected option
                            $(option).addClass("ui-state-active");
                        }
                    }
                    data.numResults++;
                }
            }
        },

        /* EVENTS */
        createEvent: function(){
            return this.each(function(){
                var $this = $(this);
                var data = $this.data("suggestselect");
                var options = data.options;
                if (typeof options.create === "function") {
                    options.create();
                }
            });
        },
        closeEvent: function(){
            return this.each(function(){
                var $this = $(this);
                var data = $this.data("suggestselect");
                var options = data.options;
                resultsPanelOpen = null;
                if (typeof options.close === "function") {
                    options.close($this);
                }
            });
        },
        openEvent: function(){
            return this.each(function(){
                var $this = $(this);
                var data = $this.data("suggestselect");
                var options = data.options;
                resultsPanelOpen = $(this);
                if (typeof options.open === "function") {
                    options.open(data.resultsPanel);
                }
            });
        },
        searchEvent: function(){
            return this.each(function(){
                var $this = $(this);
                var data = $this.data("suggestselect");
                var options = data.options;
                if (typeof options.search === "function") {
                    options.search(data.resultsPanel);
                }
            });
        },
        selectEvent: function(element, event){
            return this.each(function(){
                var $this = $(this);
                var data = $this.data("suggestselect");
                if (data.type != "select") {
                    data.initialValue = null;
                }
                var options = data.options;
                if (typeof options.select === "function") {
                    options.select(element, event);
                }
            });
        }
    };

    $.fn.suggestselect = function(method){
        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === "object" || !method) {
            return methods.create.apply(this, arguments);
        } else {
            $.error("Method " +  method + " does not exist on jQuery.suggestselect");
        }
    };

    $.fn.getAttributes = function(){
        if (!this.length) {
            return this;
        }
        var results = {};
        var attributes = $(this).get(0).attributes;

        $.each(attributes, function(index, attribute){
            results[attribute.name] = attribute.value;
        });
        return results;
    };
})(jQuery);

$(window).on("resize scroll", function(event){
    if (resultsPanelOpen !== null) {
        resultsPanelOpen.suggestselect("refresh", event);
    }
});
